module.exports = __webpack_public_path__ + "img/ug-old.774c1dcd.png";